import { DbTable } from '../db-table';
import { HttpClient } from '@angular/common/http';
import { applicationUser } from '../../../../core/_shared/models/applicationUser';
import { WebApiService } from '../../WebApiService';



export class DbApplicationUsers extends DbTable<applicationUser> {


    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi, "ApplicationUsers");
    }
}
